import { render, staticRenderFns } from "./DescargarArchivos.vue?vue&type=template&id=0120344e&"
import script from "./DescargarArchivos.vue?vue&type=script&lang=js&"
export * from "./DescargarArchivos.vue?vue&type=script&lang=js&"
import style0 from "./DescargarArchivos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports